<template>
    <div>
        <div class="box"></div>
        <div class="box2">
            <el-menu :default-active="idx" class="el-menu-demo" mode="horizontal">
                <el-menu-item index="0" @click="$router.push('live')">智慧住建</el-menu-item>
                <el-menu-item index="1" @click="$router.push('site')">智慧工地</el-menu-item>
                <el-menu-item index="2" @click="$router.push('schemeSafety')">智慧安全</el-menu-item>
                <el-menu-item index="3" @click="$router.push('schemeCartoon')">工程动画</el-menu-item>
                <el-menu-item index="4" @click="$router.push('schemeShowRoom')">项目展厅展馆</el-menu-item>
            </el-menu>
        </div>
        <div class="box3">
            <div class="main" v-for="(item,index) in dataList" :key="index" @click="donClick(index+1)">
                <img class="lef" :src="item.img">
                <div>
                    <p class="tit">{{ item.title }}</p>
                    <p class="txt">{{ item.text }}</p>
                </div>
                <span></span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "SchemeCartoon",
    data() {
        return {
            idx: '3',
            dataList: [
                {
                    id: 1,
                    img: require('../../assets/images/scheme/car/sp1.jpg'),
                    title: '景成大厦项目施工动画演示',
                    text: '景成大厦项目地处昆明市巫家坝开发片区，拟建城市新中心核心位置，西邻飞虎大道、南邻春城路[标注为：飞虎大道（拟建）、春城路（拟建）]，占地面积约2.1万平方米，总建筑面积24.34万平方米。由1栋超高层建筑与商业建筑组成...'
                },
                {
                    id: 2,
                    img: require('../../assets/images/scheme/car/sp2.jpg'),
                    title: '合肥工业大学智能制造技术研究院研发中心工程',
                    text: '本工程位于滨湖卓越城，花园大道以南、辽宁路以东、西安路以北、泰山路以西围合区域的内部。总建筑面积约 18.8万平米，地下一层，5.1万平米，地上五层，13.7万平米，基础结构形式为筏板加柱墩；地上结构形式框架结构加局部...'
                },
                {
                    id: 3,
                    img: require('../../assets/images/scheme/car/sp3.jpg'),
                    title: 'PAVILION',
                    text: 'PAVILION DAMANSARA HEIGHETS为白沙罗高地（DAMANSARA HEIGHTS）新的的大都市。（是）PAVILION集团投资兴建的另一项杰出工程。本项目包含奢华住宅、办公大楼及优质购物中心。'
                },
                {
                    id: 4,
                    img: require('../../assets/images/scheme/car/sp4.jpg'),
                    title: '深圳机场卫星厅及其配套工程建造演示',
                    text: '深圳机场卫星厅及其配套工程项目位于宝安T3国际机场航站楼北侧，包括旅客卫星厅、T3适应性改造、旅客捷运系统、行李隧道、北区配套工程。场内分布已运营地铁11号线、在建穗莞深城际铁路和拟建深茂城际铁路，共有3条下穿...'
                }
            ]
        }
    },
    methods: {
        donClick(id) {
            sessionStorage.setItem('carCode2', id);
            this.$router.push('carDetail');
            document.documentElement.scrollTop = 0;
        }
    }
}
</script>

<style lang="scss" scoped>
.box {
    height: 2.9rem;
    width: 100%;
    background: url("./img/banner/3.jpg");
    background-size: 100% 100%;
}

.box2 {
    width: 10rem;
    margin: .34rem auto .6rem;
    text-align: center;

    a {
        text-decoration: none;
    }

    .el-menu-item {
        width: 2rem;
        font-size: .2rem;
        height: .72rem;
        line-height: .72rem;
    }

    .el-menu--horizontal > .el-menu-item.is-active {
        border-bottom: 3px solid #E70F20;
        color: #E70F20;
    }

    .el-menu--horizontal > .el-menu-item {
        color: #000;
    }
}

.box3 {
    width: 12rem;
    margin: 0 auto;

    .main {
        height: 2.2rem;
        background: #FBFBFB;
        display: flex;
        position: relative;
        margin-bottom: .3rem;
        cursor: pointer;

        img.lef {
            width: 3.6rem;
            height: 2.2rem;
        }

        div {
            height: 1.6rem;
            margin: .3rem 0 0 .57rem;

            p.tit {
                font-size: .26rem;
            }

            p.txt {
                width: 6.5rem;
                font-size: .18rem;
                color: #595757;
                line-height: .36rem;
                text-align: justify;
                margin-top: .23rem;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 3;
                -webkit-box-orient: vertical;
            }
        }

        span {
            position: absolute;
            width: .38rem;
            height: .38rem;
            background: url("../../assets/images/more.png");
            background-size: 100% 100%;
            right: .32rem;
            bottom: .35rem;
            cursor: pointer;
        }
    }
}
</style>
